import { vplSiteStore } from '../store/vplstore';

export function clearSearch() {
  $(".js-search-input").val('');
  $('.js-search__results').removeClass('is-show');
  $('.js-header-search').removeClass('is-active');
  $('.js-search-wp').removeClass('is-active');
  $('body').removeClass('dropdown-open');
  $('body').removeClass('search-open');
  $('.js-header-catalog-search').removeClass('is-active');
}

export function clearHeaderMenuDropdown() {
  $('.js-header-action-item-link').removeClass('is-open');
  $('.js-header-action-item-link-dropdown').removeClass('is-show');
  $('body').removeClass('dropdown-open');
  $('body').removeClass('overlay-show');
}

/**
 * Бургер в исходное положение. Обратная анимация (класс is-static) запускается
 * ТОЛЬКО если бургер был крестом: её первый кадр — крест (полоски повёрнуты на
 * ±45°, средняя сжата в точку), поэтому на неактивном бургере класс is-static
 * заставлял иконку мигать крестом при каждом закрытии чего угодно — в том числе
 * при открытии выпадающего поиска с мобильной иконки-лупы.
 */
export function resetBurger() {
  $('.js-burger.is-active').removeClass('is-active').addClass('is-static');
}

export function closeHeaderCatalog() {
  resetBurger();
  $('.js-burger-dropdown').removeClass('is-open');
  $('.js-panel').addClass('is-active');
  $('body').removeClass('catalog-open'); // $('.js-overlay').removeClass('is-show');
  $('body').removeClass('dropdown-open');
}

export function showCatalogMenu(dropdownOpen = true) {
  clearSearch();
  clearHeaderMenuDropdown();
  closeHeaderCatalog();

  if (!$('.js-catalog').hasClass('is-active')) {
    $('.js-catalog').addClass('is-active');
    $('.js-header').find('.js-catalog-dropdown').addClass('is-open');
    $('body').addClass('dropdown-open');

  } else {
    $('.js-catalog').removeClass('is-active');
    $('.js-header').find('.js-catalog-dropdown').removeClass('is-open');
    $('body').removeClass('dropdown-open');
    $('body').removeClass('search-open');

  }
}

export function number_format(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  let n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      let k = Math.pow(10, prec);
      return '' + (Math.round(n * k) / k)
        .toFixed(prec);
    };
  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
    .split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '')
    .length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1)
      .join('0');
  }
  return s.join(dec);
}

export function num_word(value, words) {
  value = Math.abs(value) % 100;
  let num = value % 10;
  if (value > 10 && value < 20) return words[2];
  if (num > 1 && num < 5) return words[1];
  if (num == 1) return words[0];
  return words[2];
}

export function normalizeStockStatusCode(code) {
  code = String(code);

  if (code === '1') return 'in_stock';
  if (code === '0') return 'to_order';
  if (code === '-1') return 'discontinued';
  if (code === '-2') return 'individual_calculation';
  if (code === '-3') return 'discontinued';
  if (code === 'individual') return 'individual_calculation';
  if (code === 'removed') return 'discontinued';

  return code;
}

export function stockPositiveTotal(value) {
  return Math.max(0, parseInt(value, 10) || 0);
}

/* метка товара из 1С (TAS_MARKS, SAIT-149) → css-класс плашки .product-card__tags-item */
export function markClass(code) {
  const classes = {
    AKTSIYA: 'promo',
    KHIT_PRODAZH: 'hit',
    RASPRODAZHA: 'sale',
    NOVINKA: 'new',
    TAS_PRO_RECOMEND: 'recommend',
  };
  return classes[code] || 'promo';
}

export function stockStoreAmount(store) {
  return parseInt(store && store.AMOUNT, 10) || 0;
}

export function stockStoreText(store) {
  const code = normalizeStockStatusCode(store && store.STATUS_CODE);
  const amount = stockStoreAmount(store);

  if (amount > 0 || code === 'in_stock') {
    return amount + ' шт.';
  }

  if (code === 'individual_calculation') {
    return 'Индивидуальный расчет';
  }

  if (code === 'discontinued') {
    return 'Снят с продажи';
  }

  return store && store.STATUS_TEXT ? store.STATUS_TEXT : 'Под заказ';
}

// ==========
// Куки
// ==========
export function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name, value, options = {}) {

  options = {
    path: '/',
    ...options
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export function deleteCookie(name) {
  setCookie(name, "", {
    'max-age': -1
  })
}


export function decodeBase64(input) {
  if (typeof input !== 'string') return input;
  else input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  let output = "", a, b, c, d, e, f, g, i = 0;

  let map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  while (i < input.length) {
    d = map.indexOf(input.charAt(i++));
    e = map.indexOf(input.charAt(i++));
    f = map.indexOf(input.charAt(i++));
    g = map.indexOf(input.charAt(i++));

    a = (d << 2) | (e >> 4);
    b = ((e & 15) << 4) | (f >> 2);
    c = ((f & 3) << 6) | g;

    output += String.fromCharCode(a);
    if (f != 64) output += String.fromCharCode(b);
    if (g != 64) output += String.fromCharCode(c);
  }

  let string = output, charCode = 0;
  if (typeof string !== 'string') return string;
  i = 0;
  output = "";

  while (i < string.length) {
    charCode = string.charCodeAt(i);

    if (charCode < 128)
      output += String.fromCharCode(charCode),
        i++;
    else if ((charCode > 191) && (charCode < 224))
      output += String.fromCharCode(((charCode & 31) << 6) | (string.charCodeAt(i + 1) & 63)),
        i += 2;
    else
      output += String.fromCharCode(((charCode & 15) << 12) | ((string.charCodeAt(i + 1) & 63) << 6) | (string.charCodeAt(i + 2) & 63)),
        i += 3;
  }

  return output;
}

export function formatFileSize(bytes) {
  if (bytes === 0) return '0 B';

  const k = 1024;
  const sizes = ['B', 'Kb', 'Mb', 'Gb', 'Tb'];

  // Вычисляем степень (для определения единицы измерения)
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  // Форматируем число с двумя знаками после запятой
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function findGetParameter(parameterName) {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

export function setFastBuyModalTitle(titleText) {
  if (!titleText) return;

  [0, 100, 250, 500, 900, 1300].forEach((delay) => {
    setTimeout(() => {
      const modal = document.querySelector('#fastbuy');

      if (!modal) return;

      modal.querySelectorAll('.modal-title, .modal__title, h2, h3').forEach((title) => {
        const current = (title.textContent || '').trim();

        if (
          current === 'Быстрая покупка'
          || current === 'Заказать товар'
          || current === 'Связаться с нами'
          || current === 'Запросить расчет'
          || current === 'Запросить расчёт'
          || current === 'Подобрать аналог'
        ) {
          title.textContent = titleText;
        }
      });
    }, delay);
  });
}

export function fastBuy(id, titleText = '') {
  $.ajax({
    url: '/ajax/fastview.php',
    method: 'POST',
    data: { id: id },
    success: (response) => {
      const store = vplSiteStore();
      store.fastview = JSON.parse(response);
      setFastBuyModalTitle(titleText);
      $('#fastbuy').modal();
    }
  });
}

/*
 Яндекс SmartCaptcha на формах ВЫКЛЮЧЕНА (решение заказчика; серверная проверка
 тоже отключена — `if(false && … checkYandexCaptcha(...))` в
 components/vpl/form.result.new.yandex/component.php, ключи YA_CLIENT_KEY/YA_SERVER_KEY
 в init.php). Пока капча выключена, captcha.js (40 КБ gzip, отдельный домен) не
 загружается: раньше initYaCaptcha() из fastview.js (быстрый просмотр в подвале)
 тянул его на КАЖДОЙ странице. Формы ждут `window.smartCaptcha` в setInterval и
 только внутри этого ожидания ставят маску телефона (Cleave) — поэтому условия в
 семи формах учитывают переключатель: при выключенной капче ожидание завершается
 сразу. Включить: YA_CAPTCHA_ENABLED = true здесь + убрать `false &&` в component.php
 + перевыпустить ключи (см. CLAUDE.md, «1c-exchange.md → Формы»).
*/
export const YA_CAPTCHA_ENABLED = false;

export function initYaCaptcha(bytes) {
  if(!YA_CAPTCHA_ENABLED){
    return;
  }
  const store = vplSiteStore();
  if(!store.captchaInited){

    const script = document.createElement('script');
    script.src = 'https://smartcaptcha.yandexcloud.net/captcha.js';
    script.defer = true;
    document.head.appendChild(script);

    store.captchaInited = true;
  }
}

export function initYaMaps(){
  const store = vplSiteStore();
  if(!store.mapInited){

    const script = document.createElement('script');
    script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
    script.defer = true;
    document.head.appendChild(script);

    store.mapInited = true;
  }
}
/* Иконка меню из данных (PARAMS.ICON): если это svg шаблона и символ есть в инлайн-спрайте
   (blocks/footer.php, id="ico-<имя файла>") — возвращает имя для <use>, иначе '' (остаётся <img>) */
export function spriteIcon(path) {
    const m = /\/img\/svg\/([\w.-]+)\.svg$/.exec(String(path || ''));
    return (m && document.getElementById('ico-' + m[1])) ? m[1] : '';
}
